import { render } from "./Personal.vue?vue&type=template&id=51127b31&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import "./Personal.vue?vue&type=style&index=0&id=51127b31&scoped=true&lang=css"
import "./Personal.vue?vue&type=style&index=1&id=51127b31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51127b31"]])

export default __exports__